import * as api from '../../api'
import {AmplifyEventBus} from "aws-amplify-vue";


const state = {

    update_order_status : [],
    update_customer_status : [],
    update_account_receivables_status: [],

    customer_detail: [],
    customer_detail_loading: false,

    order_list_one_order: [],
    order_list_last_orders: [],
    web_account_list: [],
    web_account_list_loading: false,

    order_list_last_orders_noah: [],

    order_list_by_product_sku_hard8th: [],
    order_list_by_product_sku_14pack: [],
    order_list_by_product_sku_noahs: [],

    compare_60_120_list: [],
    compare_60_120_list_loading: false,
    report_main_data: [],
    samples_only_list: [],
    hidden_list: [],
    account_receivables_list: [],
    account_receivables_list_loading: false,
    account_receivables_detail: [],

    account_receivables_notes_log: [],
    account_receivables_notes_log_loading: false,

    is_updating_orders : false,
    is_updating_customers : false,
    is_updating_account_receivable: false,
    ar_sort_id: 0,

    store_web_shop_contact: [],

    get_call_log_loading: false,
    get_call_log: [],

    sleep_data: [],
    sleep_data_loading: false,

    vape_data: [],
    vape_data_loading: false,

    road_data: [],
    road_data_loading: false,
    road_details: [],


    ca_map_data: [],
    ca_map_loading:  false,


    menu_banner_type: 0,
    hide_sales_rep_column: 0,

    dont_sign_out: 0,

    lfb_graph_data: [],
    lfb_graph_data_loading: false,

    prospect_data: [],
    prospect_data_loading: false,

    commission_data: [],
    commission_data_loading: false,

    accounts_list: [],


    multi_show_data: [],
    multi_show_data_loading: [],
    
    pistil_history_data: [],
    pistil_history_data_loading: [],


    frootwheel_number_data: [],
    frootwheel_winner_data: [],
    frootwheel_trigger_data: [],

}

const getters = {

    update_order_status : state => state.update_order_status,
    update_customer_status : state => state.update_customer_status,
    update_account_receivables_status : state => state.update_account_receivables_status,

    customer_detail : state => state.customer_detail,
    customer_detail_loading : state => state.customer_detail_loading,

    order_list_one_order : state => state.order_list_one_order,
    order_list_last_orders : state => state.order_list_last_orders,

    web_account_list : state => state.web_account_list,
    web_account_list_loading: state => state.web_account_list_loading,

    order_list_last_orders_noah : state => state.order_list_last_orders_noah,

    order_list_by_product_sku_14pack: state => state.order_list_by_product_sku_14pack,
    order_list_by_product_sku_hard8th: state => state.order_list_by_product_sku_hard8th,
    order_list_by_product_sku_noahs: state => state.order_list_by_product_sku_noahs,

    compare_60_120_list:  state => state.compare_60_120_list,
    compare_60_120_list_loading:  state => state.compare_60_120_list_loading,
    report_main_data : state => state.report_main_data,

    menu_banner_type: state => state.menu_banner_type,
    hide_sales_rep_column: state => state.hide_sales_rep_column,


    dont_sign_out: state => state.dont_sign_out,

    samples_only_list : state => state.samples_only_list,
    hidden_list : state => state.hidden_list,
    is_updating_orders : state => state.is_updating_orders,
    is_updating_customers : state => state.is_updating_customers,
    is_updating_account_receivable: state => state.is_updating_account_receivable,
    account_receivables_list : state => state.account_receivables_list,
    account_receivables_list_loading : state => state.account_receivables_list_loading,
    account_receivables_detail : state => state.account_receivables_detail,

    account_receivables_notes_log : state => state.account_receivables_notes_log,
    account_receivables_notes_log_loading : state => state.account_receivables_notes_log_loading,

    ar_sort_id : state => state.ar_sort_id,

    store_web_shop_contact: state => state.store_web_shop_contact,

    get_call_log_loading: state => state.get_call_log_loading,
    get_call_log: state => state.get_call_log,

    sleep_data: state => state.sleep_data,
    sleep_data_loading: state => state.sleep_data_loading,

    vape_data: state => state.vape_data,
    vape_data_loading: state => state.vape_data_loading,

    road_data: state => state.road_data,
    road_data_loading: state => state.road_data_loading,
    road_details:  state => state.road_details,

    ca_map_data: state => state.ca_map_data,
    ca_map_loading: state => state.ca_map_loading,

    lfb_graph_data: state => state.lfb_graph_data,
    lfb_graph_data_loading: state => state.lfb_graph_data_loading,

    prospect_data: state => state.prospect_data,
    prospect_data_loading: state => state.prospect_data_loading,

    commission_data: state => state.commission_data,
    commission_data_loading: state => state.commission_data_loading,


    accounts_list: state => state.accounts_list,
    
    multi_show_data: state => state.multi_show_data,
    multi_show_data_loading: state => state.multi_show_data_loading,
    
    pistil_history_data: state => state.pistil_history_data,
    pistil_history_data_loading: state => state.pistil_history_data_loading,
    

    frootwheel_number_data: state=> state.frootwheel_number_data,
    frootwheel_winner_data: state=> state.frootwheel_winner_data,
    frootwheel_trigger_data: state=> state.frootwheel_trigger_data,

}


const mutations = {

    updateOrdersDatabase: (state, payload) => {
        state.is_updating_orders = true;
        api.updateOrdersDatabase({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.update_order_status = val.data
            state.is_updating_orders = false;
        })
    },

    updateCustomerDatabase: (state, payload) => {
        state.is_updating_customers = true;
        api.updateCustomerDatabase({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.update_customer_status = val.data
            state.is_updating_customers = false;
        })
    },

    updateAccountReceivables: (state, payload) => {
        state.is_updating_account_receivable = true;
        api.updateAccountReceivables({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.update_account_receivables_status = val.data
            state.is_updating_account_receivable = false;
        })
    },

    getCustomerDetail: (state, payload) => {
        state.customer_detail_loading = 1;
        api.getCustomerDetail({customer_id: payload.customer_id, is_noah: payload.is_noah, combined_shop: payload.combined_shop }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.customer_detail = val.data
            state.customer_detail_loading = 0;
        })
    },

    getMultiShop: (state, payload) => {
        state.multi_show_data_loading = 1;
        api.getMultiShop({multi_shop_name: payload.multi_shop_name }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.multi_show_data = val.data
            state.multi_show_data_loading = 0;
        })
    },
    
    

    getPistilProductInventoryHistory: (state, payload) => {
        state.pistil_history_data_loading = 1;
        api.getPistilProductInventoryHistory({customer_id: payload.customer_id, 'category': payload.category, 'start_date': payload.start_date, 'end_date': payload.end_date}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.pistil_history_data = val.data
            state.pistil_history_data_loading = 0;
        })
    },

    getRoadDetails: (state, payload) => {
        api.getRoadDetails({license_number: payload.license_number, id: payload.id, max_distance: payload.max_distance }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.road_details = val.data
        })
    },

    getSleepData: (state, payload) => {
        state.sleep_data_loading = true
        api.getSleepData({type: payload.type }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.sleep_data = val.data
            state.sleep_data_loading = false
        })
    },

    getVapeData: (state, payload) => {
        state.vape_data_loading = true
        api.getVapeData({}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.vape_data = val.data
            state.vape_data_loading = false
        })
    },

    getRoadData: (state, payload) => {
        state.road_data_loading = true
        api.getRoadData({type: payload.type }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.road_data = val.data
            state.road_data_loading = false
        })
    },

    getCAMapData: (state, payload) => {
        state.ca_map_loading = true
        api.getCAMapData({type: payload.type,center_lon: payload.center_lon, center_lat: payload.center_lat, radius: payload.radius}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.ca_map_data = val.data
            state.ca_map_loading = false
        })
    },

    markShopVisited: (state, payload) => {
        api.markShopVisited({customer_id: payload.customer_id}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            // todo: check response aber nicht wichtig
        })
    },


    getCompare60120List: (state, payload) => {
        api.getCompare60120List({plus_minus: payload.plus_minus, min_amount: payload.min_amount, percentage_drop: payload.percentage_drop, asc_desc: payload.asc_desc}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.compare_60_120_list = val.data
        })
    },

    updateCompare60120List: (state, payload) => {
        state.compare_60_120_list_loading = true;
        api.updateCompare60120List({plus_minus: payload.plus_minus, min_amount: payload.min_amount, percentage_drop: payload.percentage_drop, asc_desc: payload.asc_desc}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.compare_60_120_list_loading = false;
            state.compare_60_120_list = val.data
        })
    },

    getReportMainData: (state, payload) => {
        api.getReportMainData({ custom_month: payload.custom_month, custom_year: payload.custom_year }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.report_main_data = val.data
            state.menu_banner_type = val.data.menu_banner_type
            state.hide_sales_rep_column = val.data.hide_sales_rep_column
        })
    },

    getAccountReceivablesList: (state, payload) => {
        state.account_receivables_list_loading = true;
        api.getAccountReceivablesList({ customer_id: payload.customer_id }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}

            state.account_receivables_list_loading = false;

            if(payload.customer_id > 0) {
                state.account_receivables_detail = val.data;
            }
            else {
                state.account_receivables_list = val.data;
            }
        })
    },

    getAccountReceivablesNotesLog: (state, payload) => {
        state.account_receivables_notes_log_loading = true;
        api.getAccountReceivablesNotesLog({}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.account_receivables_notes_log = val.data
            state.account_receivables_notes_log_loading = false;
        })
    },

    getOrdersListOneOrder: (state, payload) => {
        api.getOrdersListOneOrder({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.order_list_one_order = val.data
        })
    },

    getOrdersListLastOrders: (state, payload) => {
        api.getOrdersListLastOrders({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.order_list_last_orders = val.data
        })
    },

    getWebAccountsList: (state, payload) => {
        state.web_account_list_loading = true;
        api.getWebAccountsList({sort_type: payload.sort_type }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.web_account_list = val.data;
            state.web_account_list_loading = false;
        })
    },


    storeWebShopContact: (state, payload) => {
        api.storeWebShopContact({customer_id: payload.customer_id,shop_number: payload.shop_number,contact_phone: payload.contact_phone,contact_person: payload.contact_person}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.store_web_shop_contact = val.data;
        })
    },



    getOrdersListLastOrdersNoah: (state, payload) => {
        api.getOrdersListLastOrdersNoah({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.order_list_last_orders_noah = val.data
        })
    },

    getOrdersListByProductSKU: (state, payload) => {
        api.getOrdersListByProductSKU({product_sku: payload.product_sku }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}

            if(payload.product_sku === "14PACK"){
                state.order_list_by_product_sku_14pack = val.data
            }
            if(payload.product_sku === "HARD8TH"){
                state.order_list_by_product_sku_hard8th = val.data
            }
            if(payload.product_sku === "NOAHS"){
                state.order_list_by_product_sku_noahs = val.data
            }
        })
    },


    addNewCustomerNote: (state, payload) => {
        api.addNewCustomerNote({customer_id: payload.customer_id, note: payload.note, is_noah: payload.is_noah}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.customer_detail = val.data
        })
    },

    addNewCustomerNoteAR: (state, payload) => {
        api.addNewCustomerNoteAR({customer_id: payload.customer_id, note: payload.note}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.account_receivables_detail = val.data
        })
    },

    setCustomerField: (state, payload) => {
        api.setCustomerField({is_noah: payload.is_noah, customer_id: payload.customer_id, fieldname: payload.fieldname, value: payload.value}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.customer_detail = val.data
        })
    },

    setRoadField: (state, payload) => {
        api.setRoadField({record_id: payload.record_id, fieldname: payload.fieldname, value: payload.value, max_distance: payload.max_distance, license_number: payload.license_number}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.road_details = val.data
        })
    },

    setCustomerFieldAR: (state, payload) => {
        api.setCustomerFieldAR({customer_id: payload.customer_id, fieldname: payload.fieldname, value: payload.value}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.account_receivables_detail = val.data
        })
    },

    setButtonValue: (state, payload) => {
        api.setButtonValue({customer_id: payload.customer_id, is_noah:payload.is_noah, function_button: payload.function_button, value: payload.value}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.customer_detail = val.data
        })
    },

    setOrderFlagValue: (state, payload) => {
        api.setOrderFlagValue({is_noah: payload.is_noah, customer_id: payload.customer_id,  fieldname: payload.fieldname, order_id: payload.order_id, value: payload.value}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.customer_detail = val.data
        })
    },

    getSampleOnlyList: (state, payload) => {
        api.getSampleOnlyList({}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.samples_only_list = val.data
        })
    },

    getHiddenList: (state, payload) => {
        api.getHiddenList({ }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.hidden_list = val.data
        })
    },

    getCallLog: (state, payload) => {
        state.get_call_log_loading = true;
        api.getCallLog({sort_type: payload.sort_type }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.get_call_log = val.data;
            state.next_shop_to_call_loading = false;
        })
    },

    getLfbGraphData: (state, payload) => {
        state.lfb_graph_data_loading = true;
        api.getLfbGraphData({}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.lfb_graph_data = val.data;
            state.lfb_graph_data_loading = false;
        })
    },
    setProspectField: (state, payload) => {
        state.prospect_data_loading = true;
        api.setProspectField({value: payload.value, prospectid: payload.prospectid, fieldname: payload.fieldname}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.prospect_data = val.data;
            state.prospect_data_loading = false;
        })
    },

    getCommissionData: (state, payload) => {
        state.commission_data_loading = true;
        api.getCommissionData({monthindex: payload.monthindex}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.commission_data = val.data;
            state.commission_data_loading = false;
        })
    },

    getAccountList: (state, payload) => {
        api.getAccountList({userid_pw: payload.userid_pw}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.accounts_list = val.data
        })
    },






    frootWheelNumber: (state, payload) => {
        api.frootWheelNumber( {frootwheel_number: payload.frootwheel_number, new_dollar: payload.new_dollar}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.frootwheel_number_data = val.data
        })
    },
    frootWheelWinners: (state, payload) => {
        api.frootWheelWinners( {}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.frootwheel_winner_data = val.data
        })
    },

    setFrootWheelField: (state, payload) => {
        api.setFrootWheelField({id: payload.id, fieldname: payload.fieldname, value: payload.value, origin: payload.origin}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}

            if(payload.origin === 2) {
                state.frootwheel_number_data = val.data
            }
            if(payload.origin === 3) {
                state.frootwheel_winner_data = val.data
            }

        })
    },

    frootWheelTriggers: (state, payload) => {
        api.frootWheelTriggers({is_new: payload.is_new, delete_id: payload.delete_id, start_number: payload.start_number, end_number: payload.end_number, win_dollar: payload.win_dollar, shop_name: payload.shop_name}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.frootwheel_trigger_data = val.data
        })
    },



}

const actions = {

    emptyLoadedLists: () => {
        state.order_list_one_order = [];
        state.order_list_last_orders = [];
        state.samples_only_list = [];
        state.hidden_list = [];
    },

    setARSortId0: () => {
        state.ar_sort_id = 0;
    },
    setARSortId1: () => {
        state.ar_sort_id = 1;
    },
    setARSortId2: () => {
        state.ar_sort_id = 2;
    },
    setARSortId3: () => {
        state.ar_sort_id = 3;
    },
    setARSortId4: () => {
        state.ar_sort_id = 4;
    },
    setARSortId5: () => {
        state.ar_sort_id = 5;
    },
    emptyDetailPage: () => {
        state.customer_detail = [];
    },

    setBannerType120: () => {
        state.menu_banner_type = 120;
    },

    setDontSignOut: () => {
        state.dont_sign_out = 1; // if we cll a detail page from the CA map we can't sign out or the next detail page will be signed out
    },

    updateOrdersDatabase: (context, payload) => {
        context.commit('updateOrdersDatabase', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    updateActivityDatabase: (context, payload) => {
        context.commit('updateActivityDatabase', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    updateCustomerDatabase: (context, payload) => {
        context.commit('updateCustomerDatabase', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    updateAccountReceivables: (context, payload) => {
        context.commit('updateAccountReceivables', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    updateCompanyStaffDatabase: (context, payload) => {
        context.commit('updateCompanyStaffDatabase', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getCustomerDetail: (context, payload) => {
        context.commit('getCustomerDetail', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    getMultiShop: (context, payload) => {
        context.commit('getMultiShop', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    
    getPistilProductInventoryHistory: (context, payload) => {
        context.commit('getPistilProductInventoryHistory', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getRoadDetails: (context, payload) => {
        context.commit('getRoadDetails', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    addNewCustomerNote: (context, payload) => {
        context.commit('addNewCustomerNote', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    addNewCustomerNoteAR: (context, payload) => {
        context.commit('addNewCustomerNoteAR', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getSleepData: (context, payload) => {
        context.commit('getSleepData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getVapeData: (context, payload) => {
        context.commit('getVapeData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getRoadData: (context, payload) => {
        context.commit('getRoadData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getCAMapData: (context, payload) => {
        context.commit('getCAMapData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    markShopVisited: (context, payload) => {
        context.commit('markShopVisited', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },


    getCompare60120List: (context, payload) => {
        context.commit('getCompare60120List', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    updateCompare60120List: (context, payload) => {
        context.commit('updateCompare60120List', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getReportMainData: (context, payload) => {
        context.commit('getReportMainData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getAccountReceivablesList: (context, payload) => {
        context.commit('getAccountReceivablesList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getAccountReceivablesNotesLog: (context, payload) => {
        context.commit('getAccountReceivablesNotesLog', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getOrdersListOneOrder: (context, payload) => {
        context.commit('getOrdersListOneOrder', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getOrdersListLastOrders: (context, payload) => {
        context.commit('getOrdersListLastOrders', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getWebAccountsList: (context, payload) => {
        context.commit('getWebAccountsList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    storeWebShopContact: (context, payload) => {
        context.commit('storeWebShopContact', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },



    getOrdersListLastOrdersNoah: (context, payload) => {
        context.commit('getOrdersListLastOrdersNoah', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getOrdersListByProductSKU: (context, payload) => {
        context.commit('getOrdersListByProductSKU', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setCustomerField: (context, payload) => {
        context.commit('setCustomerField', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setRoadField: (context, payload) => {
        context.commit('setRoadField', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setCustomerFieldAR: (context, payload) => {
        context.commit('setCustomerFieldAR', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setButtonValue: (context, payload) => {
        context.commit('setButtonValue', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setOrderFlagValue: (context, payload) => {
        context.commit('setOrderFlagValue', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getSampleOnlyList: (context, payload) => {
        context.commit('getSampleOnlyList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getHiddenList: (context, payload) => {
        context.commit('getHiddenList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getCallLog: (context, payload) => {
        context.commit('getCallLog', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getLfbGraphData: (context, payload) => {
        context.commit('getLfbGraphData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    setProspectField: (context, payload) => {
        context.commit('setProspectField', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getCommissionData: (context, payload) => {
        context.commit('getCommissionData', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },

    getAccountList: (context, payload) => {
        context.commit('getAccountList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },



    setFrootWheelField: (context, payload) => {
        context.commit('setFrootWheelField', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    frootWheelNumber: (context, payload) => {
        context.commit('frootWheelNumber', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    frootWheelWinners: (context, payload) => {
        context.commit('frootWheelWinners', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    frootWheelTriggers: (context, payload) => {
        context.commit('frootWheelTriggers', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },





}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

